<template>
  <div style="display: flex;">
    <div v-if="true" class="dates">
      <label>
        <span class="sr-only">From</span>
        <input
          type="date"
          :disabled="disabled"
          :value="toDate(from)"
          :max="toDate(through)"
          @input="emitStart({ selected: 'pickRange', through: through, from: $event.target.value })"
        />
      </label>
      <font-awesome-icon
        :icon="['fas', 'long-arrow-alt-right']"
        class="icon alt between-dates"
        aria-hidden="true"
      />
      <label>
        <span class="sr-only">To</span>
        <input
          type="date"
          :disabled="disabled"
          :value="toDate(through)"
          :min="toDate(from)"
          @input="emitStart({ selected: 'pickRange', from: from, through: $event.target.value })"
        />
      </label>
    </div>
    <button
      v-else
      type="button"
      class="left"
      :class="{ active: listShowing === 'pickRange' }"
      :disabled="disabled"
      @click="select('pickRange')"
    >
      Pick Range
    </button>
    <button
      type="button"
      class="middle"
      :class="{ active: listShowing === 'all' }"
      :disabled="listShowing === 'all' || disabled"
      @click="select('all')"
    >
      All Time
    </button>
    <button
      type="button"
      class="middle"
      :class="{ active: listShowing === 'recent14' }"
      :disabled="listShowing === 'recent14' || disabled"
      @click="select('recent14')"
    >
      Past 14 Days
    </button>
    <button
      type="button"
      class="right"
      :class="{ active: listShowing === 'recent30' }"
      :disabled="listShowing === 'recent30' || disabled"
      @click="select('recent30')"
    >
      Past 30 Days
    </button>
  </div>
</template>

<script>
import moment, { isMoment } from 'moment';

export default {
  name:'DateFilters',

  props: {
    from: {
      type: Object,
      required: false,
      default: null,
    },
    through: {
      type: Object,
      required: false,
      default: null,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    }
  },

  data() {
    return {
      listShowing: 'recent14',
    }
  },

  methods: {
    toDate(d) {
      if (!d) return null;
      if (isMoment(d)) return d.format('YYYY-MM-DD');
      return moment(d).format('YYYY-MM-DD');
    },
    select(selection) {
      this.listShowing = selection;

      switch (selection) {
        case 'all':
          this.emitExact({
            selected: selection,
            from: null,
            through: null
          })
          break;
        case 'recent14':
          this.emitExact({
            selected: selection,
            from: moment().add(-14, 'day'),
            through: moment()
          })
          break;
        case 'recent30':
          this.emitExact({
            selected: selection,
            from: moment().add(-30, 'day'),
            through: moment()
          })
          break;
        case 'upcoming':
          this.emitExact({
            selected: selection,
            from: moment(),
            through: null
          })
          break;
        case 'pickRange':
          this.emitStart({
            selected: selection,
            from: this.from,
            through: this.through
          })
          break;
        default:
            break;
      }
    },
    emitStart({ selected, from, through }) {
      this.listShowing = selected;

      if (from && !isMoment(from)) {
        from = moment(from);
      }
      if (through && !isMoment(through)) {
        through = moment(through);
      }
      from = from ? from.startOf('day') : null;
      through = through ? through.endOf('day') : null;

      this.$emit('change', { selected, from, through })
    },
    emitExact({ selected, from, through }) {
      if (from && !isMoment(from)) {
        from = moment(from);
      }
      if (through && !isMoment(through)) {
        through = moment(through);
      }
      this.$emit('change', { selected, from, through })
    }
  }
}
</script>

<style lang="scss" scoped>
button.left{
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
}
button.middle{
  border-radius: 0px;
}
button.right{
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
}
button {
  color-scheme: light;
  display: flex;
  justify-content: center;
  flex-wrap: nowrap;
  align-items: center;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #d1d1d1;
  padding: 10px;
  margin: 0;
  height: 46px;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  text-align: center;

  @media screen and (min-width: $md-min) {
    height: 46px;
    flex-wrap: nowrap;
  }

  label {
    margin: 0;
  }

  input {
    border: 0;
    background: transparent;
    line-height: 2;
    font-size: 14px;
    font-weight: 500;
    text-transform: uppercase;
    max-width: 145px;
    height: 46px;
    padding: 0 16px;
  }

  svg {
    opacity: 0.8;
  }

  &:hover {
    box-shadow: 0 2px 4px rgb(0 0 0 / 18%);
    border-color: #bababa;
  }
}
.dates {
  color-scheme: light;
  display: flex;
  justify-content: center;
  flex-wrap: nowrap;
  align-items: center;
  background: #fff;
  border-radius: 8px;
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
  border: 1px solid #d1d1d1;
  padding: 0;
  margin: 0;
  height: 46px;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  text-align: center;

  @media screen and (min-width: $md-min) {
    height: 46px;
    flex-wrap: nowrap;
  }

  label {
    margin: 0;
  }

  input {
    border: 0;
    background: transparent;
    line-height: 2;
    font-size: 14px;
    font-weight: 500;
    text-transform: uppercase;
    max-width: 145px;
    height: 46px;
    padding: 0 16px;
  }

  svg {
    opacity: 0.8;
  }

  &:hover {
    box-shadow: 0 2px 4px rgb(0 0 0 / 18%);
    border-color: #bababa;
  }
}
</style>
